import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../../helpers/request';
import { getQueryKeys } from '../../../../queries/queryKeys';
import { message as messageAntd } from 'antd';

const createTemplates = async ({
  name,
  message,
  message2,
  serviceCompanyId,
  registrationTypeId,
}) => {
  const objTemplate = {
    Name: name,
    Message: message,
    Message2: message2,
    ServiceCompanyId: serviceCompanyId,
    RegistrationTypeId: registrationTypeId,
  };

  const res = await request.post(
    `/HousingStock/house_access_type`,
    JSON.stringify(objTemplate),
    'Не удалось добавить шаблон',
    'Error'
  );
  return res;
};

const useCreateTemplates = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(createTemplates, {
    onSuccess: async (data, { serviceCompanyId, registrationTypeId }) => {
      if (data !== 'Error') {
        messageAntd.success('Шаблон успешно создан', 2);
        queryClient.invalidateQueries(
          getQueryKeys.templates({ serviceCompanyId, registrationTypeId })
        );
      }
    },
  });

  return {
    createAsync: mutation.mutateAsync,
    loading: mutation.isLoading,
  };
};

export { useCreateTemplates };
